/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Testimonial_3_QuoteInputs */

const en_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My son's launch monitor numbers jumped after three lessons. Best coach in Iowa.`)
};

const es_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los números de mi hijo en el launch monitor se dispararon tras tres clases. El mejor entrenador de Iowa.`)
};

const de_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Launch-Monitor-Werte meines Sohnes sind nach drei Golfstunden sprunghaft gestiegen. Der beste Trainer in Iowa.`)
};

const zh_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上了三节课后，我儿子的弹道监测仪数据大幅提升。爱荷华最好的教练。`)
};

const ar_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قفزت أرقام ابني على جهاز تحليل الضربات بعد ثلاثة دروس فقط. أفضل مدرّب في آيوا.`)
};

const fr_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les chiffres de mon fils au launch monitor ont bondi après trois cours. Le meilleur coach de l'Iowa.`)
};

const vi_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ số máy đo quỹ đạo của con trai tôi tăng vọt sau ba buổi học. Huấn luyện viên giỏi nhất Iowa.`)
};

const sw_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takwimu za mwanangu kwenye launch monitor zilipanda sana baada ya masomo matatu. Kocha bora zaidi Iowa.`)
};

const th_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตัวเลขจากลอนช์มอนิเตอร์ของลูกชายผมพุ่งขึ้นหลังเรียนไปสามครั้ง โค้ชที่ดีที่สุดในไอโอวา`)
};

const bs_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brojke mog sina na launch monitoru naglo su porasle nakon tri lekcije. Najbolji trener u Iowi.`)
};

const ja_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`息子のローンチモニターの数値が3回のレッスン後に大きく伸びました。アイオワで最高のコーチです。`)
};

const ko_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세 번의 레슨 후 아들의 론치 모니터 수치가 크게 올랐습니다. Iowa 최고의 코치입니다.`)
};

const pt_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os números do meu filho no launch monitor dispararam após três aulas. O melhor treinador de Iowa.`)
};

const it_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I numeri del launch monitor di mio figlio sono schizzati in alto dopo tre lezioni. Il miglior allenatore dell'Iowa.`)
};

const sv_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min sons siffror på launch monitorn sköt i höjden efter tre lektioner. Bästa tränaren i Iowa.`)
};

const nl_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De launchmonitorcijfers van mijn zoon schoten omhoog na drie lessen. De beste coach van Iowa.`)
};

const da_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min søns launch monitor-tal steg markant efter tre lektioner. Den bedste træner i Iowa.`)
};

const nb_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch monitor-tallene til sønnen min skjøt i været etter tre timer. Den beste treneren i Iowa.`)
};

const fi_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poikani launch monitor -lukemat paranivat kolmen opetuskerran jälkeen. Iowan paras valmentaja.`)
};

const pl_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyniki mojego syna na launch monitorze skoczyły po trzech lekcjach. Najlepszy trener w Iowa.`)
};

const ru_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`После трёх уроков показатели сына на launch monitor резко выросли. Лучший тренер в Iowa.`)
};

const tr_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oğlumun launch monitor değerleri üç dersten sonra fırladı. Iowa'nın en iyi antrenörü.`)
};

const hi_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तीन पाठों के बाद मेरे बेटे के लॉन्च मॉनिटर के आंकड़े काफ़ी बढ़ गए। Iowa के सबसे अच्छे कोच।`)
};

const id_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angka launch monitor anak saya melonjak setelah tiga pelajaran. Pelatih terbaik di Iowa.`)
};

const ms_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angka launch monitor anak saya meningkat mendadak selepas tiga pelajaran. Jurulatih terbaik di Iowa.`)
};

const cs_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnoty mého syna na launch monitoru po třech lekcích prudce vzrostly. Nejlepší trenér v Iowě.`)
};

const el_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Οι τιμές του γιου μου στο launch monitor εκτοξεύτηκαν μετά από τρία μαθήματα. Ο καλύτερος προπονητής στην Iowa.`)
};

const he_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הנתונים של הבן שלי ב-launch monitor זינקו אחרי שלושה שיעורים. המאמן הטוב ביותר ב-Iowa.`)
};

const af_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My seun se launch monitor-syfers het ná drie lesse gespring. Beste afrigter in Iowa.`)
};

const hu_home_testimonial_3_quote = /** @type {(inputs: Home_Testimonial_3_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fiam launch monitoros értékei három óra után ugrásszerűen javultak. Iowa legjobb edzője.`)
};

/**
* | output |
* | --- |
* | "My son's launch monitor numbers jumped after three lessons. Best coach in Iowa." |
*
* @param {Home_Testimonial_3_QuoteInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_testimonial_3_quote = /** @type {((inputs?: Home_Testimonial_3_QuoteInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Testimonial_3_QuoteInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_testimonial_3_quote(inputs)
	if (locale === "de") return de_home_testimonial_3_quote(inputs)
	if (locale === "zh") return zh_home_testimonial_3_quote(inputs)
	if (locale === "ar") return ar_home_testimonial_3_quote(inputs)
	if (locale === "fr") return fr_home_testimonial_3_quote(inputs)
	if (locale === "vi") return vi_home_testimonial_3_quote(inputs)
	if (locale === "sw") return sw_home_testimonial_3_quote(inputs)
	if (locale === "th") return th_home_testimonial_3_quote(inputs)
	if (locale === "bs") return bs_home_testimonial_3_quote(inputs)
	if (locale === "ja") return ja_home_testimonial_3_quote(inputs)
	if (locale === "ko") return ko_home_testimonial_3_quote(inputs)
	if (locale === "pt") return pt_home_testimonial_3_quote(inputs)
	if (locale === "it") return it_home_testimonial_3_quote(inputs)
	if (locale === "sv") return sv_home_testimonial_3_quote(inputs)
	if (locale === "nl") return nl_home_testimonial_3_quote(inputs)
	if (locale === "da") return da_home_testimonial_3_quote(inputs)
	if (locale === "nb") return nb_home_testimonial_3_quote(inputs)
	if (locale === "fi") return fi_home_testimonial_3_quote(inputs)
	if (locale === "pl") return pl_home_testimonial_3_quote(inputs)
	if (locale === "ru") return ru_home_testimonial_3_quote(inputs)
	if (locale === "tr") return tr_home_testimonial_3_quote(inputs)
	if (locale === "hi") return hi_home_testimonial_3_quote(inputs)
	if (locale === "id") return id_home_testimonial_3_quote(inputs)
	if (locale === "ms") return ms_home_testimonial_3_quote(inputs)
	if (locale === "cs") return cs_home_testimonial_3_quote(inputs)
	if (locale === "el") return el_home_testimonial_3_quote(inputs)
	if (locale === "he") return he_home_testimonial_3_quote(inputs)
	if (locale === "af") return af_home_testimonial_3_quote(inputs)
	if (locale === "hu") return hu_home_testimonial_3_quote(inputs)
	return en_home_testimonial_3_quote(inputs)
});